import { DeviceAlertType, DeviceAlertTypeSummary } from "@core/types";

export const CRITICLE_ALERTS: Array<DeviceAlertType> = [
    DeviceAlertType.DOWNTIME,
    DeviceAlertType.FAILOVER,
    DeviceAlertType.TEMPERATURE
];

export const WARNING_ALERTS: Array<DeviceAlertType> = [
    DeviceAlertType.IP_CHANGE,
    DeviceAlertType.RSRP,
    DeviceAlertType.RSRQ,
    DeviceAlertType.RSSI,
    DeviceAlertType.SINR,
    DeviceAlertType.NR_RSRP,
    DeviceAlertType.NR_RSRQ,
    DeviceAlertType.NR_SINR,
    DeviceAlertType.ETHERNET_INTERFACE_CHAGNE,
    DeviceAlertType.BANDWIDTH,
    DeviceAlertType.WEB_UI_LOGIN_FAILURE,
    DeviceAlertType.PCI_HOPPING,
    DeviceAlertType.DRY_CONTACT,
    DeviceAlertType.SERIAL_CONNECTOR
];

export const INFO_ALERTS: Array<DeviceAlertType> = [
    DeviceAlertType.FIRMWARE,
    DeviceAlertType.CONFIGURATION,
    DeviceAlertType.UNIT_POWERED_UP,
    DeviceAlertType.CELL_BOUNCING,
    DeviceAlertType.NETWORK_TECHNOLOGY_CHANGE,
    DeviceAlertType.GEO_FENCE
];